/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Phoneverified_No1Inputs */

const he_profile_phoneverified_no1 = /** @type {(inputs: Profile_Phoneverified_No1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר הטלפון עדיין לא אומת`)
};

const en_profile_phoneverified_no1 = /** @type {(inputs: Profile_Phoneverified_No1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone not verified yet`)
};

/**
* | output |
* | --- |
* | "Phone not verified yet" |
*
* @param {Profile_Phoneverified_No1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_phoneverified_no1 = /** @type {((inputs?: Profile_Phoneverified_No1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Phoneverified_No1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_phoneverified_no1(inputs)
	return en_profile_phoneverified_no1(inputs)
});
export { profile_phoneverified_no1 as "profile_phoneVerified_no" }